var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1685_30426)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1685_30426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27734 3.44079L18.0803 2.42379C19.7753 2.27879 20.2103 2.37579 21.2763 3.14979L25.6823 6.24679C26.4093 6.77979 26.6523 6.92479 26.6523 7.50479V24.4898C26.6523 25.5538 26.2643 26.1838 24.9083 26.2798L8.87934 27.2478C7.86234 27.2968 7.37734 27.1518 6.84434 26.4738L3.60034 22.2638C3.01834 21.4888 2.77734 20.9088 2.77734 20.2308V5.13379C2.77734 4.26379 3.16534 3.53679 4.27734 3.44079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0803 2.42379L4.27734 3.44179C3.16534 3.53779 2.77734 4.26379 2.77734 5.13479V20.2318C2.77734 20.9098 3.01834 21.4898 3.60034 22.2648L6.84434 26.4748C7.37734 27.1528 7.86234 27.2978 8.87934 27.2488L24.9083 26.2808C26.2643 26.1848 26.6513 25.5548 26.6513 24.4908V7.50479C26.6513 6.95479 26.4343 6.79479 25.7913 6.32679L25.6823 6.24679L21.2763 3.14979C20.2113 2.37579 19.7753 2.27879 18.0803 2.42379ZM9.24334 7.22679C7.93434 7.31479 7.63734 7.33479 6.89334 6.73079L5.00334 5.23079C4.81134 5.03679 4.90834 4.79479 5.39234 4.74679L18.6623 3.77879C19.7753 3.68179 20.3563 4.06979 20.7923 4.40879L23.0683 6.05379C23.1643 6.10179 23.4063 6.39179 23.1163 6.39179L9.41234 7.21479L9.24434 7.22579L9.24334 7.22679ZM7.71634 24.3438V9.92479C7.71634 9.29579 7.91034 9.00479 8.49134 8.95679L24.2293 8.03679C24.7633 7.98879 25.0053 8.32779 25.0053 8.95679V23.2788C25.0053 23.9088 24.9083 24.4418 24.0353 24.4888L8.97534 25.3608C8.10434 25.4088 7.71634 25.1188 7.71634 24.3438ZM22.5843 10.6978C22.6813 11.1338 22.5843 11.5698 22.1473 11.6178L21.4223 11.7638V22.4088C20.7923 22.7468 20.2113 22.9408 19.7273 22.9408C18.9523 22.9408 18.7573 22.6988 18.1773 21.9728L13.4303 14.5218V21.7318L14.9323 22.0698C14.9323 22.0698 14.9323 22.9408 13.7203 22.9408L10.3803 23.1348C10.2833 22.9408 10.3803 22.4578 10.7193 22.3608L11.5903 22.1188V12.5858L10.3803 12.4888C10.2833 12.0538 10.5253 11.4248 11.2033 11.3758L14.7873 11.1348L19.7273 18.6828V12.0048L18.4673 11.8608C18.3703 11.3278 18.7573 10.9408 19.2423 10.8928L22.5843 10.6978Z",
    fill: "#000008"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1685_30426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.597656 0.8125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1685_30426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.597656 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotion);
export default __webpack_public_path__ + "static/media/notion.a5f6e6e121558eb8f7978988bc4f8826.svg";
export { ForwardRef as ReactComponent };